<template>
    <div class="billing-address-form">
        <div class="container">
            <div class="header">
                <div class="title">Fatura Adresi</div>
            </div>
            <div class="form">
                <div class="column" v-if="form.isCompany">
                    <Input placeHolder="John" v-model="form.name" :title="'Şirket Adı'" />
                </div>
                <div class="column" v-else>
                    <Input placeHolder="John" v-model="form.name" :title="'Adı'" />
                    <Input placeHolder="Doe" v-model="form.surname" :title="'Soyadı'" />
                </div>
                <div class="column">
                    <Input
                        v-if="!form.isCompany"
                        placeHolder="00000000000"
                        v-model="form.idenity"
                        :title="'TC Kimlik'"
                    />
                    <Input placeHolder="johndoe@supsis.com" v-model="form.mail" :title="'E-Posta'" />
                </div>
                <div class="column" v-if="form.isCompany">
                    <div id="input">
                        <div class="title">
                            <label>Vergi Dairesi</label>
                        </div>
                        <a-auto-complete
                            v-model="form.taxOffice"
                            :data-source="taxOffices"
                            style="width: 100%"
                            @search="onSearch"
                        />
                    </div>
                    <Input placeHolder="00000000000" v-model="form.taxNumber" :title="'Vergi Numarası'" />
                </div>
                <div class="column">
                    <Input placeHolder="Türkiye" v-model="form.country" :title="'Ülke'" />
                    <Input placeHolder="İstanbul" v-model="form.city" :title="'Şehir'" />
                </div>
                <Input placeHolder="TeknoPark" v-model="form.address" :title="'Adress'" />
                <div class="billing-checkboxes">
                    <div class="billing-addreses-type">
                        <a-input type="checkbox" v-model="form.isCompany" />
                        <label>Şirket Faturası olarak kayıt et</label>
                    </div>
                    <div class="billing-addreses-type">
                        <a-input
                            type="checkbox"
                            :value="userAgreement"
                            @change="$emit('userAgreementAccepted', $event.target.checked)"
                        />
                        <label @click="() => (userAgreementModal = true)">{{
                            $t("message.confidentialityAgreementCheck")
                        }}</label>
                    </div>
                </div>
            </div>
        </div>
        <a-modal
            class="agreementModal"
            height="400px"
            :title="$t('message.confidentialityAgreement')"
            :visible="userAgreementModal"
            @ok="
                () => {
                    userAgreementModal = false;
                    userAgreement = true;
                }
            "
            @cancel="() => (userAgreementModal = false)"
        >
            <div style="height: 400px; overflow: auto">
                Güvenliğiniz bizim için önemli. Bu sebeple bizimle paylaşacağınız kişisel verileriz hassasiyetle
                korunmaktadır. Supsis.com, veri sorumlusu olarak, bu gizlilik ve kişisel verilerin korunması politikası
                ile, hangi kişisel verilerinizin hangi amaçla işleneceği, işlenen verilerin kimlerle ve neden
                paylaşılabileceği, veri işleme yöntemimiz ve hukuki sebeplerimiz ile; işlenen verilerinize ilişkin
                haklarınızın neler olduğu hususunda sizleri aydınlatmayı amaçlıyoruz. Toplanan Kişisel Verileriniz,
                Toplanma Yöntemi ve Hukuki Sebebi IP adresiniz ve kullanıcı aracısı bilgileriniz, sadece analiz yapmak
                amacıyla ve çerezler (cookies) vb. teknolojiler vasıtasıyla, otomatik veya otomatik olmayan yöntemlerle
                ve bazen de analitik sağlayıcılar, reklam ağları, arama bilgi sağlayıcıları, teknoloji sağlayıcıları
                gibi üçüncü taraflardan elde edilerek, kaydedilerek, depolanarak ve güncellenerek, aramızdaki hizmet ve
                sözleşme ilişkisi çerçevesinde ve süresince, meşru menfaat işleme şartına dayanılarak işlenecektir.
                Kişisel Verilerinizin İşlenme Amacı Bizimle paylaştığınız kişisel verileriniz sadece analiz yapmak
                suretiyle; sunduğumuz hizmetlerin gerekliliklerini en iyi şekilde yerine getirebilmek, bu hizmetlere
                sizin tarafınızdan ulaşılabilmesini ve maksimum düzeyde faydalanılabilmesini sağlamak, hizmetlerimizi,
                ihtiyaçlarınız doğrultusunda geliştirebilmek ve sizleri daha geniş kapsamlı hizmet sağlayıcıları ile
                yasal çerçeveler içerisinde buluşturabilmek ve kanundan doğan zorunlulukların (kişisel verilerin talep
                halinde adli ve idari makamlarla paylaşılması) yerine getirilebilmesi amacıyla, sözleşme ve hizmet
                süresince, amacına uygun ve ölçülü bir şekilde işlenecek ve güncellenecektir. Toplanan Kişisel Verilerin
                Kimlere ve Hangi Amaçlarla Aktarılabileceği Bizimle paylaştığınız kişisel verileriniz; faaliyetlerimizi
                yürütmek üzere hizmet aldığımız ve/veya verdiğimiz, sözleşmesel ilişki içerisinde bulunduğumuz, iş
                birliği yaptığımız, yurt içi ve yurt dışındaki 3. şahıslar ile kurum ve kuruluşlara ve talep halinde
                adli ve idari makamlara, gerekli teknik ve idari önlemler alınması koşulu ile aktarılabilecektir.
                Kişisel Verileri İşlenen Kişi Olarak Haklarınız KVKK madde 11 uyarınca herkes, veri sorumlusuna
                başvurarak aşağıdaki haklarını kullanabilir: Kişisel veri işlenip işlenmediğini öğrenme, Kişisel
                verileri işlenmişse buna ilişkin bilgi talep etme, Kişisel verilerin işlenme amacını ve bunların amacına
                uygun kullanılıp kullanılmadığını öğrenme, Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı
                üçüncü kişileri bilme, Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların
                düzeltilmesini isteme, Kişisel verilerin silinmesini veya yok edilmesini isteme, (e) ve (f) bentleri
                uyarınca yapılan işlemlerin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
                İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi
                aleyhine bir sonucun ortaya çıkmasına itiraz etme, Kişisel verilerin kanuna aykırı olarak işlenmesi
                sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme, haklarına sahiptir. Yukarıda sayılan
                haklarınızı kullanmak üzere info@supsis.com üzerinden bizimle iletişime geçebilirsiniz. Supsis.com
                sitesinde yer alan bütün yazılar, materyaller, resimler, ses dosyaları, animasyonlar, videolar, dizayn,
                tasarım ve düzenlemelerimizin telif hakları 5846 numaralı yasa telif hakları korunmaktadır. Bunlar
                Supsis.com‘un yazılı izni olmaksızın ticari olarak herhangi bir şekilde kopyalanamaz, dağıtılamaz,
                değiştirilemez, yayınlanamaz. İzinsiz ve kaynak belirtilmeksizin kopyalama ve kullanımı yapılamaz.
                Supsis.com’daki harici linkler ayrı bir sayfada açılır. Yayınlanan yazı ve yorumlardan şirket
                sorumludur. Supsis.com’da hiçbir bildirim yapmadan, herhangi bir zaman değişikliğe gidebilir. Çerezler
                Supsis.com, internet sitesinin kullanım amaçları doğrultusunda ve bunlarla sınırlı olmak üzere gerekli
                gördüğü durumlarda kullanıcıların bilgisayarlarına “Cookie” (çerez) olarak adlandırılan ve kullanıcıyı
                tanımlamaya yardımcı olan yazılımı yerleştirebilir. Cookie kullanımı, Supsis.com Web Sitesi
                ziyaretlerinde ve internet üzerinde standart bir politika olarak kabul edilen uygulamadır. Kullanıcılar
                istekleri doğrultusunda işlevsel kullanım amacıyla yerleştirilecek Cookie’leri kişisel web tarayıcı
                ayarları sayesinde engelleyebilme haklarını saklı tutarlar.
            </div>
        </a-modal>
    </div>
</template>

<script>
import Input from "../../Input.vue";
import { mapState } from "vuex";
import TaxOffices from "../../../utils/taxOffices";

export default {
    name: "BillingAddressForm",
    props: {
        userAgreement: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            userAgreementModal: false,
            taxOffices: [],
            form: {
                name: null,
                surname: null,
                idenity: null,
                mail: null,
                country: null,
                city: null,
                address: null,
                taxNumber: null,
                isCompany: false,
                taxOffice: null,
            },
        };
    },
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
        }),
    },
    mounted() {
        this.form = {
            name: this.billingDetail?.name,
            surname: this.billingDetail?.surname,
            idenity: this.billingDetail?.identityNumber,
            mail: this.billingDetail?.email,
            country: this.billingDetail?.billingCountry,
            city: this.billingDetail?.billingCity,
            address: this.billingDetail?.billingAddress,
            isCompany: this.billingDetail?.billingType === "company",
            taxNumber: this.billingDetail?.taxNumber,
            taxOffice: this.billingDetail?.taxOffice,
        };
    },
    methods: {
        onSearch(searchText) {
            this.taxOffices =
                !searchText || searchText.length < 2
                    ? TaxOffices.slice(0, 5)
                    : TaxOffices.filter((s) => s.toUpperCase().includes(searchText.toUpperCase()));
        },
    },
    watch: {
        form: {
            handler() {
                this.$emit("input", this.form);
            },
            deep: true,
        },
    },
    components: { Input },
};
</script>
<style lang="scss">
.billing-address-form {
    width: 100%;
    height: 100%;

    .container {
        padding: 36px 36px;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 10px;
        background-color: white;

        .header {
            margin-bottom: 24px;

            .title {
                font-size: 24px;
                color: #144167;
                font-weight: bold;
                margin-bottom: 15px;
            }
        }
    }

    .form {
        .column {
            display: flex;
            justify-content: center;
            align-items: center;

            :first-child {
                margin-right: 10px;
            }
        }

        .billing-checkboxes {
            display: flex;
            align-items: center;
            width: 100%;
            gap: 10px;
        }
        .billing-addreses-type {
            display: flex;
            align-items: center;
            gap: 10px;
            input {
                accent-color: #ec4b1d;
                width: 20px;
                height: 20px;
            }
            label {
                margin: 0;
            }
        }
    }

    #input {
        margin-bottom: 10px;

        .title label {
            font-size: 14px !important;
            font-weight: bold;
        }

        .input-container {
            padding: 10px 5px !important;
            height: auto !important;

            input {
                font-size: 14px !important;
            }
        }
    }
}
</style>
